(function(){
	$(document).ready(function () {
    //Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
    var start = $("#arriveInput").attr("value");
    var end = $("#departureInput").attr("value");
    var firstClick = 0;

    var limitDate = $("#limitDate").attr("value").split(",");

    $("#datesCalendar").datepicker({
      minDate: start,
      numberOfMonths: 2,
      dateFormat: "mm/dd/yy",
      maxDate: new Date(limitDate[0], parseInt(limitDate[1]) - 1, 31),
      beforeShowDay: function (date) {
        $.datepicker._defaults.dateFormat = "mm/dd/yy";
        var startDate = $.datepicker.parseDate("mm/dd/yy", start);
        var endDate = $.datepicker.parseDate("mm/dd/yy", end);

        if (date.getTime() == startDate.getTime()) {
          return [true, "start-day"];
        } else {
          if (date.getTime() == endDate.getTime()) {
            return [true, "end-day"];
          } else {
            if (
              date.getTime() > startDate.getTime() &&
              date.getTime() < endDate.getTime()
            ) {
              return [true, "days"];
            } else {
              return [true, ""];
            }
          }
        }
      },
      onSelect: function (date) {
        var selectedDate = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          date
        );

        if (firstClick == 0) {
          start = date;
          end = date;
          firstClick = 1;
        } else {
          if (selectedDate <= start) {
            end = start;
            start = date;
          } else {
            end = date;
          }
          firstClick = 0;
        }

        $("#arriveInput").attr("value", start);
        $("#departureInput").attr("value", end);
        console.log(
          "Selected date: " + start + "; input's current value: " + end
        );
        $("#pickup").val(start + "   /   " + end);
      },
      onChangeMonthYear: function () {
        setTimeout(function () {
          calendarH();
        }, 80);
      },
    });
    var booking_date_format = "yy/mm/dd";
    var booking_min_date = "";
    var booking_allow_children = false;
    // $("#pickup").mask("Z9-Z9-9999   -   Z9-Z9-9999", {
    //   translation: {
    //     Z: {
    //       pattern: /[0-9]/,
    //       optional: true,
    //     },
    //   },
    // });
  });

  	//To create after event 
	$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
	$.datepicker._updateDatepicker = function(inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
					afterShow.apply((inst.input ? inst.input[0] : null)); // trigger custom callback
	}


	

}());
